<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="create-item"
        color="#2CBF56"
        depressed
        rounded
      >
        Новая персона
        <v-icon class="ml-2" size="20">mdi-plus-circle</v-icon>
      </v-btn>
    </template>
    <v-card class="rounded-lg">
      <v-card-title class="pb-0">
        <v-row align="center" justify="space-between">
          <v-col class="px-0" cols="auto"></v-col>
          <v-col class="px-0" cols="auto">
            <p class="dialog-title">Создание персоны</p>
          </v-col>
          <v-col class="px-0" cols="auto">
            <v-btn icon @click="resetState">
              <v-icon size="30" color="error">mdi-close-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="padding: 15px 40px">
        <v-form ref="form" v-model="valid">
          <div class="d-flex flex-row justify-space-between">
            <div class="input-wrapper" style="width: 48%">
              <label for="first_name"
                >Имя <span class="red--text">*</span>
              </label>
              <v-text-field
                autocomplete="given-name"
                placeholder="Введите имя персоны"
                v-model="newPerson.first_name"
                id="first_name"
                :rules="rules.required"
                outlined
                dense
              />
            </div>
            <div class="input-wrapper" style="width: 48%">
              <label for="last_name"
                >Фамилия <span class="red--text">*</span>
              </label>
              <v-text-field
                autocomplete="family-name"
                placeholder="Введите фамилию персоны"
                v-model="newPerson.last_name"
                id="last_name"
                :rules="rules.required"
                outlined
                dense
              />
            </div>
          </div>
          <div class="input-wrapper">
            <label for="patronymic">Отчество </label>
            <v-text-field
              autocomplete="additional-name"
              placeholder="Введите отчество персоны"
              v-model="newPerson.patronymic"
              id="patronymic"
              outlined
              dense
            />
          </div>
          <div class="d-flex flex-row justify-space-between">
            <div class="input-wrapper" style="width: 48%">
              <label for="iin">ИИН <span class="red--text">*</span> </label>
              <v-text-field
                placeholder="Введите ИИН персоны"
                v-model="newPerson.iin"
                :rules="rules.individual_identifier"
                id="iin"
                counter
                maxlength="12"
                hide-spin-buttons
                outlined
                dense
              />
            </div>
            <div class="input-wrapper" style="width: 48%">
              <label for="last_name">Должность </label>
              <v-text-field
                autocomplete="family-name"
                placeholder="Введите должность"
                v-model="newPerson.position"
                id="last_name"
                outlined
                dense
              />
            </div>
          </div>
          <div class="input-wrapper">
            <label for="branch">Филиал <span class="red--text">*</span> </label>
            <v-select
              @change="
                getGroups();
                getDevices();
              "
              placeholder="Выберите филиал"
              v-model="newPerson.branch_id"
              :rules="rules.required"
              :items="branches"
              item-text="title"
              item-value="id"
              id="branch"
              outlined
              dense
            />
          </div>
          <div v-if="newPerson.branch_id" class="input-wrapper">
            <label for="group">Группа</label>
            <v-select
              placeholder="Выберите группу"
              v-model="newPerson.group_id"
              :items="groups"
              :rules="rules.required"
              item-text="title"
              item-value="id"
              id="group"
              outlined
              dense
            />
          </div>
          <div v-if="newPerson.branch_id" class="input-wrapper">
            <label for="devices">Планшеты</label>
            <v-autocomplete
              placeholder="Выберите планшеты"
              v-model="newPerson.devices"
              :items="devices"
              :rules="rules.required"
              :search-input.sync="searchDevice"
              item-text="device_key"
              item-value="id"
              id="devices"
              multiple
              outlined
              deletable-chips
              small-chips
              dense
              ref="select"
            >
              <template #append-item>
                <div class="append">
                  <v-btn @click="$refs.select.blur()" color="primary">OK</v-btn>
                </div>
              </template>
            </v-autocomplete>
          </div>
          <div class="input-wrapper" style="width: 48%">
            <label for="telegram_id">Телеграм ID </label>
            <v-text-field
              placeholder="Введите телеграм ID персоны"
              v-model="newPerson.telegram_id"
              id="telegram_id"
              outlined
              dense
            />
          </div>
          <div class="input-wrapper">
            <label for="facePhoto"
              >Фотография персоны <span class="red--text">*</span>
            </label>
            <label class="input" v-if="!newPerson.face_photo">
              <input
                @change="onFileChange($event)"
                type="file"
                accept="image/png, image/jpeg"
              />
              Загрузить
              <v-icon color="#3474d3" size="20" class="pl-2"
                >mdi-arrow-down-circle-outline</v-icon
              >
            </label>
            <div class="preview" v-else>
              <v-img height="125" width="125" :src="image" />
              <v-btn class="delete-btn" @click="removeImage" icon>
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </v-form>

        <v-btn
          @click="create"
          :loading="loading"
          :disabled="!valid"
          class="save-btn"
          depressed
          >Сохранить</v-btn
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CreatePerson",
  props: {
    branches: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      newPerson: {
        iin: "",
        branch_id: "",
        group_id: "",
        first_name: "",
        last_name: "",
        patronymic: "",
        telegram_id: "",
        face_photo: "",
        is_guest: false,
        card_id: 12345,
        devices: [],
      },
      searchDevice: "",
      groups: [],
      devices: [],
      image: "",

      rules: {
        required: [
          (v) => {
            if (v) if (0 < v.length <= 255) return true;
            return "Поле обязательно для заполнения";
          },
        ],
        mobile_phone: [
          (v) => {
            if (v && v?.length > 0) {
              return (
                /^[+7]\d{10}/.test(v) ||
                "Номер должен соответсовать следующему формату: +77001112233"
              );
            }
            return "Поле обязательно для заполнения";
          },
        ],
        individual_identifier: [
          (v) => {
            if (v && v.length > 0) {
              return /^\d{12}/.test(v) || "Введите корректный ИИН";
            }
            return "Поле обязательно для заполнения";
          },
        ],
      },
    };
  },
  watch: {
    "newPerson.devices"() {
      this.searchDevice = "";
    },
  },
  methods: {
    resetState() {
      this.newPerson = Object.assign(
        {},
        {
          iin: "",
          branch_id: "",
          group_id: "",
          first_name: "",
          last_name: "",
          patronymic: "",
          telegram_id: "",
          face_photo: "",
          card_id: 12345,
          devices: [],
          is_guest: false,
        }
      );
      this.loading = false;
      this.$refs.form.reset();
      this.dialog = false;
    },
    async create() {
      this.loading = true;
      if (this.newPerson.patronymic === "") delete this.newPerson.patronymic;
      let formData = new FormData();
      for (let o in this.newPerson) {
        if (this.newPerson[0] !== null) formData.append(o, this.newPerson[o]);
      }
      try {
        await this.$axios.post("persons/create/", formData);
        this.$root.$emit(
          "showCustomSuccess",
          `Персона ${this.newPerson.first_name} был успешно создан`
        );
        this.$emit("refreshData");
      } catch (result) {
        this.$root.$emit("showCustomError", result);
      } finally {
        this.resetState();
      }
    },
    async getDevices() {
      try {
        const response = await this.$axios.get("devices/short/");
        this.devices = response.data;
      } catch (e) {
        this.$root.$emit(
          "showCustomError",
          "Ошибка во время получения списка устройств"
        );
      }
    },
    async getGroups() {
      try {
        const response = await this.$axios.get("groups/short/", {
          params: {
            branch_id: this.newPerson.branch_id,
          },
        });
        this.groups = response.data;
      } catch (e) {
        this.$root.$emit("showDefaultError");
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      const reader = new FileReader();
      const vm = this;
      this.newPerson.face_photo = file;

      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage() {
      this.newPerson.face_photo = "";
    },
    test() {
      console.log(this.newPerson.devices);
    },
  },
};
</script>

<style scoped lang="scss">
.create-item {
  width: 240px;
  height: 41px;

  font-family: Gilroy-Medium, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1px;
  color: #ffffff;
  text-transform: none !important;
}

.dialog-title {
  font-family: Gilroy-Medium, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 31px;
  text-align: center;
  color: #3474d3;
}

.preview {
  position: relative;
  height: 125px;
  width: 125px;

  .delete-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.append {
  position: sticky;
  bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  background: white;
}
</style>
